import { hyphenateHTML } from 'hyphen/de';

const hyphen = () => {
  Array.from(document.querySelectorAll('.c-post__title')).forEach(el => {
    hyphenateHTML(el.innerHTML, { debug: false, minWordLength: 5 }).then(
      result => {
        // eslint-disable-next-line no-param-reassign
        el.innerHTML = result;
      },
    );
  });
};

hyphen();



// WEBPACK FOOTER //
// ./src/scripts/modules/hyphen.js